import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { jobs } from "../../../../../redux/jobs/action";
import { selectListItems } from "../../../../../redux/library/selector";
import PageLoader from "../../../../../components/PageLoader";
import { selectJobsListItems } from "../../../../../redux/jobs/selector";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import MobileViewTable from "../../../../../common/components/mobile-view-table.component";
import storePersist from "../../../../../redux/storePersist";
import _ from "lodash";
import Table from "../../../../../common/components/table-manager/v1.1/table";



const RapAgentJobs = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { height, width } = useWindowDimensions();
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectJobsListItems)

  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'RAPAgent']);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'OrderId', headerName: 'OrderId' },
      { field: 'RAPAgentName', headerName: 'RAPAgent Name' },
      { field: 'RAPName', headerName: 'RAP Name' },
      { field: 'IsRTOMobilityJob', headerName: 'RTO Mobility JOB', cellRenderer: 'yesNoRenderer' },
      { field: 'IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      { field: 'PickupInfo.location', headerName: 'From Address', isAddressFormat: true },
      { field: 'DeliveryInfo.location', headerName: 'To Address', isAddressFormat: true },
      { field: 'IsRTOQCEnabled', headerName: 'Is RTO QC Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'MobilityJobNotes', headerName: 'Mobility Job Notes', },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = () => {
    dispatch(jobs.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/smart-booking/jobs/list`, entity: 'jobs', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
         "Filters": [
          {
            "FieldName": "RAPAgentId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      
      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchJobs()

  }, [pageData, pageSize])

  const handleDelete = async (data: any) => {
      await dispatch(jobs.delete({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/delete`,
        entity: 'orders',
        jsonData: {
          Records: [
            {
              Id: data?.Id
  
  
            }
          ]
        }
      }))
      await fetchJobs()
    }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          headingName="Job" />
      }
    </>

  );
};

export default RapAgentJobs;
